import { render, staticRenderFns } from "./LogoComponent.vue?vue&type=template&id=612ae4f6&"
import script from "./LogoComponent.vue?vue&type=script&lang=js&"
export * from "./LogoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports